import { UsersLayout } from '@layouts/user/UsersLayout'
import SegmentsPage from '@pages/user/SegmentsPage'
import TransactionsPage from '@pages/user/TransactionsPage'
import UsersPage from '@pages/user/UsersPage'
import { Navigate, RouteObject } from 'react-router-dom'
import userDetailRoutes from './UserDetailRoutes'

const userRoutes: RouteObject[] = [
  {
    element: <UsersLayout />,
    children: [
      { path: 'list', element: <UsersPage /> },
      { path: 'segments', element: <SegmentsPage /> },
      { path: 'transactions', element: <TransactionsPage /> },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: ':userId',
    children: userDetailRoutes,
  },
]

export default userRoutes
